import React, { useState, useEffect } from 'react';
import { Form, Button, InputGroup, Input, InputGroupAddon } from "reactstrap";
import useGlobal from '../../store';
import CurrencySymbol from '../General/CurrencySymbol';


const EditConnectionForm = (props) => {

    const [isSaving, setIsSaving] = useState(false);

    const [response, userActions] = useGlobal(
        state => state.response,
        actions => actions.userActions
    );

    useEffect(() => {
        if(!response || response.type !== "updatebudget") {
            return;
        }
        setIsSaving(false);
    }, [response]);

    const [formState, setFormState] = useState({
        connectionID: props.connectionID,
        userID: props.userID,
        budget: props.budget || 0
    });

    useEffect(() => {
        setFormState({
            connectionID: props.connectionID,
            userID: props.userID,
            budget: props.budget || 0
        });
    }, [props]);

    const submitForm = async (event) => {
        event.preventDefault();
        console.log('submitting form...');
        setIsSaving(true);
        const justFormData = new FormData(event.target);
        var object = {};
        justFormData.forEach((value, key) => {object[key] = value});
        const formData = { ...formState };

        console.log('BUDGET FORM DATA', formData, props);
        userActions.updateBudget(formData);
    }

    const handleInputChange = (event) => {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        let formFields = { ...formState };
        formFields[name] = value;
        setFormState(formFields);
    }

    return (
        <Form onSubmit={submitForm} className="kt-form kt-form--label-right">
            <div className="form-group">
                <label>Budget</label>
                <InputGroup>
                    <InputGroupAddon addonType="prepend"><CurrencySymbol></CurrencySymbol></InputGroupAddon>
                    <Input placeholder="Budget" name="budget" value={formState.budget || ''} onChange={handleInputChange} />
                </InputGroup>
            </div>

            <div className="form-group">
                <Button color="success" type="submit">
                    Save Changes
                    { isSaving ? <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> : <></> }
                </Button>
            </div>
            
        </Form>);
}
export default EditConnectionForm;